// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AffiliateInline_wrapper__I1E0l"};